var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNewSupply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0498 2.04999H4.1498V4.14999M4.1498 11.85H2.0498V13.95L4.1498 11.85ZM13.9498 13.95H11.8498V11.85L13.9498 13.95ZM11.8498 4.14999H13.9498V2.04999L11.8498 4.14999Z",
    stroke: "#000",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15 2.1529C2.2523 3.40485 1 5.5563 1 8C1 8.357 1.0266 8.70735 1.07805 9.05M9.05 14.9216C8.70244 14.9738 8.35146 15.0001 8 15C5.5563 15 3.40485 13.7477 2.1529 11.85M14.9216 6.95C14.9734 7.29265 15 7.643 15 8C15 10.4437 13.7477 12.5952 11.85 13.8471M6.95 1.07805C7.29757 1.02592 7.64854 0.999831 8 1C10.4437 1 12.5952 2.2523 13.8471 4.15",
    stroke: "#000",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewSupply);
export default __webpack_public_path__ + "static/media/icon--new-supply.9ff371a38ed24604a02a06b667275e1b.svg";
export { ForwardRef as ReactComponent };